import request from "@/global/request/request";
import API from "@/global/request/api";

const expertService = {
  expertConst() {
    return request.get(API.expertConst);
  },
  expertCreate(params) {
    return request.post(API.expertCreate, params);
  },
  expectLatest() {
    return request.get(API.expertLatest);
  },
  expertIndustryJobs() {
    return request.get(API.expertIndustryJobs);
  }
};

export default expertService;
